(function (window, undefined) {
  'use strict';
  angular.module('cbl.cartadebitoint.wa').constant('CDINT_CONSTANTS', {
    BASE_ROOT: '/CBL-CARTADEBITOINT-WA/app/',
    REST_ROOT: '/CBL-CARTADEBITOINT-MF/services/api-',
    REST_CLIENTI_ROOT: '/MSF-CUSTOMERDATA-MF/api/',
    REST_PROSPECTMANAGER_ROOT: '/MSF-PROSPECTMANAGER-MF/',
    COMPONENTS_PATH: 'components/',
    NAZIONE_SPEDIZIONE_DEFAULT: '086',
    //API
    REST: {
      GENERAL: {
        LABEL: 'generale/label',
        TAB: 'generale/tab',
        USER: 'generale/utente',
        LOG: 'generale/log',
        FIELDCONFIGURATOR: 'generale/fieldConfigurator/' // generale/fieldConfigurator/:nomeConfigurazione
      },
      ANAGRAFICA: {
        DETTAGLIO: 'anagrafica/anagrafica/', // anagrafica/:idPratica
        DETTAGLIO_ANA: 'anagrafica/anagrafica/recuperaAnagrafica/', // anagrafica/:ndg
        DETTAGLIO_COI: 'anagrafica/anagrafica/recuperaListaNdgPerCoi/' // anagrafica/:ndg
      },
      DOCUMENTO: {
        ENTE_RILASCIO: 'documento/enterilascio'
      },
      TIPO_CARTA: 'cpt/tipoCarta/', //generale/tipocarta/:idProdotto
      TIPO_CARTA_PER_ID: 'cpt/prodotto/', //generale/tipocarta/:idPratica
      DOMINI: 'generale/domini/', // generale/domini//:codiceDominio
      PRATICA: {
        CREA: 'pratica/pratica',
        DETTAGLIO: 'pratica/pratica/', // pratica/:idPratica
        CONTOCORRENTE: 'pratica/pratica/{idPratica}/contocorrente',
        DATI_CONTO_CORRENTE: 'pratica/recuperaPraticaCc/', // recuperaPraticaCc/:idPratica,
        DEF_PRODOTTO: '/definizione', // pratica/:idPratica/definizione
        DATI_AGGIUNTIVI: '/datiaggiuntivi', // pratica/:idPratica/datiaggiuntivi,
        DATI_AML: '/datiAml', // pratica/:idPratica/datiAml,
        QUESTIONARI: '/questionari', // pratica/:idPratica/questionari,
        COMPLETA: '/completa', // pratica/:idPratica/completa,
        ANNULLA: '/annulla',
        RIFIUTA: '/rifiuta',
        PROSPETTOPERSONAFISICA: 'pratica/verifica/',
        VERIFICAPRESAINCARICO: '/verificaPresaInCarico',
        PRENDIINCARICO: '/prendiInCarico',
        RILASCIAPRATICA: '/rilasciaPratica',
        VERIFICA_CONTO_LIGHT: 'pratica/verificaContoLight'
      },
      ACCETTAZIONE: 'api/NaturalPerson/Accept',
      CPT: 'cpt/pratica/',
      QUESTIONARI: {
        NEXI: 'questionari/privacynexi/' // questionari/privacynexi/:idPratica
      },
      RICERCA: {
        CLIENTI: 'Customer/Search', // Da combinare con REST_CLIENTI_ROOT
        CONTICORRENTI: 'contocorrente/conticorrenti/',
        RAPPORTI_DELEGATI:'contocorrente/rapportiDelegati/'//:ndg
      },
      POST_VENDITA: {
        CREA: 'cartaPostVendita/pratica/',
        DETTAGLIO: 'cartaPostVendita/pratica/', // pratica/:ndg/:idPratica
        CARTA_NDG: 'cartaPostVendita/carte/',
        //        CONTI_NDG: 'cartaPostVendita/carta/elencoConti/',
        CONTI_NDG: 'contocorrente/conticorrenti/',
        FUNZIONI: 'cartaPostVendita/carta/funzioni/',
        ELENCO_BLOCCO: 'cartaPostVendita/carte/blocco',
        ELENCO_CONDIZIONI: 'cartaPostVendita/carte/condizioni',
        ELENCO_LIMITI: 'cartaPostVendita/carta/{codProdotto}/limiti',
        ANNULLA: 'cartaPostVendita/pratica/{id}/annulla',
        RECUPERA: 'cartaPostVendita/pratica/datiaggiuntivi/' // pratica/datiaggiutnivi/:idPratica
      },
      REQ_LOTT: {
        CREA_RICHIESTA: 'reqLott/crea/',
        RECUPERA_LISTA_PRODOTTI: 'reqLott/recuperaListaProdotti/',
        // RECUPERA_LISTA_PRODOTTI: 'http://localhost:3000/recuperaListaProdotti',
        // RECUPERA_INDIRIZZI_DEFAULT: '/CBL-FILIALE-WA-2.0/assets/mock/indirizzo-default.json'
        RECUPERA_INDIRIZZI_DEFAULT: 'reqLott/recuperaIndirizzoDefault',
        CERCA_LOTTI: 'reqLott/cerca/',
        STATI_LOTTI: 'reqLott/recuperaStatiLotto/'
      }
    },
    STATO_PRATICA: {
      IN_CORSO: 'INCORSO',
      CONSOLIDATA: 'CONSOLIDATA',
      PRESENTATA: 'PRESENTATA',
      DAREVISIONARE: 'DAREVISIONARE',
      ACCETTATA: 'ACCETTATA',
      ANNULLATA: 'ANNULLATA',
      RIFIUTATA: 'RIFIUTATA'
    },
    SPECIALIZZAZIONI: {
      LIGHT: 'PROPOSTACARTADEBITOINTERNAZIONALE',
      SMALLBUSINESS: 'PROPOSTACARTADEBITOINTERNAZIONALESTD',
      CONSUMER: 'PROPOSTACARTADEBITOINTCONSUMER',
      MAINTENANCE_CARTA_DEBITO: 'MAINTENANCE_CARTA_DEBITO'
    },
    FUNZIONI: {
      ATTIVA_BLOCCO: 'APLBLC',
      RIMUOVI_BLOCCO: 'RMZBLC',
      DUP_CARTA: 'DUPCRT',
      RIF_CARTA: 'RIFCRT',
      MOD_INTESTA: 'MODINT',
      MOD_CONDIZIONI: 'MODCND',
      MOD_LIMITI: 'MODLMT',
      MOD_CONTO: 'MODCNT',
      MOD_INDIRIZZO: 'MODIND'
    },
    CANALE: {
      PROMOTORE: 'BRIO_PROMOTORE',
      FILIALE: 'FILIALE',
      BANCACLOUD: 'BANCACLOUD'
    }
  });
})(window);



//////////////////
// WEBPACK FOOTER
// ./app/app.constants.js
// module id = 0
// module chunks = 0